module.exports = __webpack_public_path__ + "img/code-download.9a543e28.svg";